import { render } from "./InfoCardComponent.vue?vue&type=template&id=a4f76384"
import script from "./InfoCardComponent.vue?vue&type=script&lang=js"
export * from "./InfoCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__